export const formatNumber = (value: any): string => {
  const number = Number(value); // Próba konwersji wartości na liczbę
  if (isNaN(number)) {
    // Jeśli wartość nie jest liczbą, zwróć ją bez zmian lub zwróć pusty string, błąd itp.
    console.error("formatNumber: provided value cannot be converted to a number", value);
    return ""; // lub wartość domyślna, która ma sens w kontekście użycia
  }

  // Jeśli wartość jest liczbą, kontynuuj z logiką formatowania
  if (number % 1 !== 0) {
    return number.toFixed(2);
  } else {
    return number.toString();
  }
};

// Pobierz id kategorii po kodzie
export const getCategoryIdByCode = (codes: any, categories: any[]) => {
  const codesArray = Array.isArray(codes) ? codes : [codes];

  return codesArray.map((code) => {
    const category = categories.find((x) => x.code === code);
    return category ? category.id : null;
  });
};

// Pobierz wszystkie produkty dla wskazanych kategorii
export const getProductsByCategoryIds = (categoryIds: any[], products: any[]) => {
  const idsArray = Array.isArray(categoryIds) ? categoryIds : [categoryIds];

  return products.filter((product: any) => idsArray.includes(product.product.productCategoryId));
};

export const getDataProducts = (products: any[], vat: number) => {
  const data = [];
  for (const p of products) {
    const nettValue = Number(p.sumPrice.toFixed(2));
    const grossvalue = nettValue * (1 + vat / 100);
    data.push({
      id: p.id,
      productName: p.name,
      amount: p.amount.toFixed(2),
      unit: p.unit,
      priceUnit: p.unitPrice.toFixed(2),
      priceSum: nettValue.toFixed(2),
      priceGross: grossvalue.toFixed(2),
    });
  }

  return data;
};

export const getBasicUrlLogoImage = () => {
  return `https://s3.doma.pl/sklepy/`;
};

export const getBasicUrlSystemImage = () => {
  return `https://s3.doma.pl/systemy/`;
};

export const getBasicUrlAdditionalPageImage = () => {
  return `https://s3.doma.pl/raport/`;
};

export const showMoney = (value: number) => {
  return (
    value.toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) || 0
  );
};

export const getEdgeNameByType = (type: any) => {
  switch (type) {
    case 1:
      return `Typ ${type} (Okap)`;
    case 2:
      return `Typ ${type} ()`;
    case 3:
      return `Typ ${type} (Kalenica narożna)`;
    case 4:
      return `Typ ${type} (Koszowa)`;
    case 5:
      return `Typ ${type} (Kalenica)`;
    case 7:
      return `Typ ${type} (Szczytowa lewa)`;
    case 6:
      return `Typ ${type} (Szczytowa prawa)`;
    case 8:
      return `Typ ${type} (2 pionowe połacie)`;
    case 9:
      return `Typ ${type} (Otwór)`;
    case 10:
      return `Typ ${type} (Dach-ściana)`;
    case 11:
      return `Typ ${type} (Okno)`;
    case 12:
      return `Typ ${type} (Komin)`;
    case 99:
      return `Typ ${type} (Niezdefiniowana)`;
    case 91:
      return `Typ ${type} (Pusta)`;
    default:
      return "Pozostała";
  }
};

export const getColorByEdgeType = (type: number) => {
  switch (type) {
    case 1: // Okap
      return "#007bff"; // niebieski
    case 2: // (niewidoczny, opcjonalny)
      return "#6c757d"; // szaro-niebieski
    case 3: // Kalenica narożna
      return "#ff9800"; // pomarańczowy
    case 4: // Koszowa
      return "#4caf50"; // zielony
    case 5: // Kalenica pozioma
      return "#ffa726"; // jasnopomarańczowy
    case 6: // Szczytowa prawa
      return "#fdd835"; // żółty
    case 7: // Szczytowa lewa
      return "#fbc02d"; // ciepłożółty
    case 9: // Otwór inny
      return "#bdbdbd"; // jasnoszary
    case 10: // Połać dach-ściana
      return "#757575"; // ciemnoszary
    case 11: // Okno
      return "#64b5f6"; // jasnoniebieski
    case 12: // Komin
      return "#8d6e63"; // ceglasty
    case 99: // Niezdefiniowana
      return "#d32f2f"; // intensywny czerwony – wymaga poprawy
    case 91: // Pusta
      return "#eeeeee"; // bardzo jasny szary
    default:
      return "#000000"; // czarny jako fallback
  }
};
